<template lang="pug">
    v-dialog(v-model="openDialog"   max-width="80%")
        v-card
            v-toolbar.elevation-0(color="white")
                v-row
                    v-col(md="11" style="margin-top:10px")
                        v-toolbar-title Search Admin From Another Business Unit
                    v-col(md="1" class="justify-content-center text-center")
                        v-btn(icon dark style="color: black" @click="handleClose")
                            v-icon close
            v-divider

            div.pb-6(v-if="dataBu.length == 0")
                v-card(elevation="0" height="420px")
                    div(style="padding:20px 40px 70px 40px")
                        v-text-field(style="margin-bottom:-25px " flat outlined append-icon='search' placeholder='Search Business Unit' v-model='keyword'  )
                        label(style="margin-top:-40px;font-style: italic;color: #555") Minimum 5 character
                    
                    div(v-if="dataBu.length === 0 && statusRes === 200" style="margin-top:-30px" class="col-auto card justify-content-center text-center")
                        img(src="../assets/not-found.jpg" class="img-contact" style="width:10%;height:10%")
                        br
                        label(style="font-weight:bold; font-size:18px") Data Not Found
                        br
                        label(style="color: var(--gray-500, #667085);font-size:14px") No Data, Please try again later
                    div(v-else class="col-auto card justify-content-center text-center")
                        img(src="../assets/vector.png" class="img-contact" style="width:5%;height:5%")
                        br
                        label(style="color: var(--gray-500, #667085);") Please search your business unit
            div.pb-6(v-else)
                v-card(elevation="0" )
                    div(style="padding:20px 40px 0px 40px")
                        v-text-field(style="margin-bottom:-25px " flat outlined append-icon='search' placeholder='Search Business Unit' v-model='keyword'  )
                        label(style="margin-top:-40px;font-style: italic;color: #555") Minimum 5 character
                v-card( elevation="0" class="card-contact" v-for="data in dataBu" )
                    div.title-contact {{ data.business_unit && data.business_unit.bu_name }}
                    div(class="subtitle-contact pb-1") Contact us via the link below
                    
                    div(class="mt-6" v-for="admin in data.admin")
                        v-btn(
                            rounded
                            color="primary"
                            dark
                            :href="`https://mail.google.com/mail/?view=cm&fs=1&to=${admin.email}&su=${subject}&body=${bodyEmail}`"
                            target="_blank"
                            class="elevation-0 pa-4 mr-3 text-lowercase"
                        ) 
                            v-icon.mr-2 email 
                            | {{ admin.email }}

                        v-btn(
                            rounded
                            color="green"
                            dark
                            class="elevation-0 pa-4"
                            :href="`https://wa.me/${admin.msisdn}?text=${bodyWhatsApp}`"
                            target='_blank'
                            v-if="admin.msisdn"
                        ) 
                            img(src="../assets/ic_whatsapp.svg" class="mr-2")
                            | {{ admin.msisdn }}
                  
</template>

<script>
import axios from "axios";
export default {
name:"ModalSearch",
props :["openDialog"],
data(){
    return {
        subject: "Question Memo",
        bodyEmail: "Hi Admin,%0D%0A%0D%0AI need your help for iMemo TechConnect%0D%0A%0D%0AThanks",
        bodyWhatsApp: "Hi Admin,%0A%0AI need your help for iMemo TechConnect",
        keyword:"",
        dataBu :[],
        statusRes : 0
    }
},
mounted(){
console.log( localStorage.getItem("token"))
},
methods :{
    handleClose() {
      this.$emit("closeModal", false);
    },
},
watch :{
    keyword(data){
        let token = localStorage.getItem("token");
        if(data.length >= 5){
        axios.get(process.env.VUE_APP_API + `/business-unit/another-bu?bu_name=${data}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.dataBu = res.data.data
          this.statusRes = res.data.status
        })
        .catch((err) => {
          this.$toaster.error(err, { icon: "error" });
        })
        .finally(() => (this.loading = false));

        }
    }
}
}
</script>

<style>

</style>